import { render, staticRenderFns } from "./CurriculumList.vue?vue&type=template&id=75edba90&scoped=true"
import script from "./CurriculumList.vue?vue&type=script&lang=js"
export * from "./CurriculumList.vue?vue&type=script&lang=js"
import style0 from "./CurriculumList.vue?vue&type=style&index=0&id=75edba90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75edba90",
  null
  
)

export default component.exports